import { useCallback, useEffect, useState } from 'react';

import { getRequirementTypeConfig } from '../views/academicOffers/studyPlans/api/study-plan-curriculums';
import { RequirementTypeConfigResponse } from '../views/academicOffers/studyPlans/curriculum/parts/CurriculumDegreeActivities/types/response';

export interface RequirementTypeConfig extends RequirementTypeConfigResponse {
  isSingle: boolean;
  loading: boolean;
}

const DEFAULT_CONFIG: RequirementTypeConfigResponse = {
  availables: ['fixed'],
  default: 'fixed',
};

/**
 * Resolves the requirement types available for the current tenant and the
 * default one. When a single type is available, consumers should hide the
 * selector (pre-filled with the default) and the columns that display it.
 */
export function useRequirementTypeConfig(): RequirementTypeConfig {
  const [config, setConfig] = useState<RequirementTypeConfigResponse>(
    DEFAULT_CONFIG,
  );
  const [loading, setLoading] = useState<boolean>(true);

  const fetchConfig = useCallback(async () => {
    setLoading(true);
    const { data } = await getRequirementTypeConfig();
    if (data && Array.isArray(data.availables) && data.availables.length > 0) {
      setConfig({ availables: data.availables, default: data.default });
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return {
    ...config,
    isSingle: config.availables.length === 1,
    loading,
  };
}
